import { reloadPage } from '../utils/browser';

interface StartupState {
    loadingTimeout?: ReturnType<typeof setTimeout>;
    coachLoaded?: number;
}

const startupState: StartupState = {};

export function clearStartupLoadingTimeout(): void {
    if (startupState.loadingTimeout) {
        clearTimeout(startupState.loadingTimeout);
        startupState.loadingTimeout = undefined;
    }
}

export function markCoachLoaded(): void {
    startupState.coachLoaded = Date.now();
    window.coachLoaded = startupState.coachLoaded; // Do not remove! electron app checks this var
}

export function initializeStartupLoadingTimeout(): void {
    startupState.loadingTimeout = setTimeout(() => {
        console.error(new Error('No response from coach application. Reloading...'));
        reloadPage();
    }, 10000);
}
